'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HotelList = require('./HotelList');

var _HotelList2 = _interopRequireDefault(_HotelList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// RecommendHotels

function RecommendHotels(_ref) {
  var i18n = _ref.i18n,
      hotels = _ref.hotels,
      location = _ref.location,
      search = _ref.search;

  return _react2.default.createElement(
    'div',
    { className: 'full-width-box recommended-hotels' },
    _react2.default.createElement(
      'div',
      { className: 'fluid-conditions' },
      _react2.default.createElement(
        'h2',
        { className: 'toggle-title' },
        i18n.hotelInformation.recommendedHotels
      ),
      _react2.default.createElement(
        'div',
        { className: 'hotel-list-box' },
        _react2.default.createElement(_HotelList2.default, { i18n: i18n, items: hotels, location: location, search: search })
      )
    )
  );
}

// containers


RecommendHotels.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  hotels: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object.isRequired
};

exports.default = RecommendHotels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RecommendHotels.js
// module id = 1222
// module chunks = 0